import React, { useState } from "react";
import "./styles/theme.css";
import Header from "./components/Header";
import TabNav from "./components/TabNav";
import HomePage from "./components/HomePage";
import KundliMatchForm from "./components/KundliMatchForm";
import BirthChartForm from "./components/BirthChartForm";
import PoojaTab from "./components/PoojaTab";
import AstrologerTab from "./components/AstrologerTab";
import PoojaMeetingJoin from "./components/PoojaMeetingJoin";
import DashboardTab from "./components/DashboardTab";


// The backend builds WhatsApp video-call links as an absolute URL to
// /api/pooja/bookings/<id>/join/<token>/ (see pooja/models.py generate_meeting_link()
// and pooja/urls.py 'pooja-booking-join'). This app has no router — it's plain
// tab state — so on load we check the URL ourselves and, if it matches that
// exact pattern, render the public join page standalone instead of the normal
// tabbed app. NOTE: this only works if your static host serves index.html for
// unmatched deep paths (a SPA fallback rewrite) — see chat notes.
function getJoinParamsFromUrl() {
  const match = window.location.pathname.match(
    /^\/api\/pooja\/bookings\/([^/]+)\/join\/([^/]+)\/?$/
  );
  return match ? { bookingId: match[1], token: match[2] } : null;
}

const TABS = [
  { key: "home", label: "Home", icon: "⌂", Component: HomePage },
  { key: "match", label: "Kundli Match", icon: "♡", Component: KundliMatchForm },
  { key: "chart", label: "Birth Chart", icon: "☉", Component: BirthChartForm },
  { key: "pooja", label: "Pooja with Pandit Ji", icon: "🪔", Component: PoojaTab },
  { key: "astrologer", label: "Astrologer", icon: "✦", Component: AstrologerTab },
  { key: "dashboard", label: "Dashboard", icon: "📋", Component: DashboardTab },
];

function App() {
  const [active, setActive] = useState("home");

  // Standalone public route — bypasses the tabbed app entirely.
  const joinParams = getJoinParamsFromUrl();
  if (joinParams) {
    return <PoojaMeetingJoin bookingId={joinParams.bookingId} token={joinParams.token} />;
  }

  const Active = TABS.find((t) => t.key === active).Component;
  // Home page renders one tile per tab (minus itself) — same TABS array
  // TabNav uses, so a new tab automatically appears on the homepage too.
  const homeTabs = TABS.filter((t) => t.key !== "home");

  return (
    <div style={{ minHeight: "100vh" }}>
      <Header />
      <TabNav tabs={TABS} active={active} onChange={setActive} />
      <main style={styles.main}>
        <Active
          tabs={homeTabs}
          onNavigate={setActive}
          onOpenAstrologer={() => setActive("astrologer")}
        />
      </main>
      <footer style={styles.footer}>
        Kundli Milan · Vedic astrology, computed precisely · Reports powered by Prokerala
      </footer>
    </div>
  );
}

const styles = {
  main: { padding: "32px 16px 60px" },
  footer: {
    textAlign: "center", fontSize: 12.5, color: "var(--ink-soft)",
    padding: "18px 16px 32px",
  },
};

export default App;